
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import classes from './styles/Alpha.scss';

export default class Alpha extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={classes.Alpha}>{this.props.children}</div>
        );
    }
}
